import { render, staticRenderFns } from "./BlankLabel.vue?vue&type=template&id=06b30775&"
import script from "./BlankLabel.vue?vue&type=script&lang=js&"
export * from "./BlankLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports